import { createRootRoute, Outlet } from '@tanstack/react-router'
import { DevTierPanel } from '@/components/dev/DevTierPanel'
import { PlaybackProvider } from '@/providers/PlaybackProvider'
import { WerkshopProvider } from '@/providers/WerkshopProvider'

export const rootRoute = createRootRoute({
  component: () => (
    <PlaybackProvider>
      <WerkshopProvider>
        <Outlet />
        <DevTierPanel />
      </WerkshopProvider>
    </PlaybackProvider>
  ),
  // Surface render-time errors with a real stack instead of the
  // TanStack Router default component, which can serialise some
  // thrown values as `{}` in the WKWebView console. Logging the
  // full message + stack to console.error gives us something
  // debuggable from the Xcode log stream on the iPad.
  errorComponent: ({ error }) => {
    const err = error as Error & { stack?: string }
    console.error('[route-error]', {
      name: err?.name,
      message: err?.message,
      stack: err?.stack,
    })
    return (
      <div className="min-h-[100dvh] bg-surface-base p-6 font-mono text-xs text-content-primary overflow-auto">
        <h1 className="text-sm font-bold mb-3">Route error</h1>
        <div className="mb-2">
          <span className="text-content-tertiary">name:</span> {err?.name}
        </div>
        <div className="mb-2">
          <span className="text-content-tertiary">message:</span>{' '}
          {err?.message ?? '(no message)'}
        </div>
        <pre className="whitespace-pre-wrap text-[10px] text-content-tertiary">
          {err?.stack ?? '(no stack)'}
        </pre>
      </div>
    )
  },
})
